import React, { useState } from 'react';
import { Box, Typography, Collapse, Button } from '@mui/material';
import { ExpandMore, ExpandLess } from '@mui/icons-material';
import CopyButton from './CopyButton';

// A collapsible "fill an online form" breakdown: one labelled, copyable row per
// form field. `rows` is [{ key, label, value }]. Defaults open for the first
// entry (defaultOpen), collapsed for the rest; each is still toggleable.
const FormFieldsPane = ({ title, rows, defaultOpen = false, addressType }) => {
  const [open, setOpen] = useState(defaultOpen);

  return (
    <Box sx={{ mt: 1.5 }}>
      <Button
        size="small"
        onClick={() => setOpen((o) => !o)}
        startIcon={open ? <ExpandLess /> : <ExpandMore />}
        sx={{ textTransform: 'none', color: 'text.secondary', px: 0.5 }}
      >
        {title}
      </Button>
      <Collapse in={open}>
        <Box
          sx={{
            mt: 1,
            bgcolor: 'background.paper',
            borderRadius: 1,
            border: '1px solid',
            borderColor: 'divider',
          }}
        >
          {rows.map((row) => (
            <Box
              key={row.key}
              sx={{
                display: 'flex',
                alignItems: 'center',
                gap: 1,
                px: 1.5,
                py: 0.5,
                borderBottom: '1px solid',
                borderColor: 'divider',
                '&:last-of-type': { borderBottom: 'none' },
              }}
            >
              <Typography
                variant="caption"
                color="text.secondary"
                sx={{ width: 140, flexShrink: 0 }}
              >
                {row.label}
              </Typography>
              <Typography
                variant="body2"
                color="text.secondary"
                sx={{ flex: 1, minWidth: 0, wordBreak: 'break-word' }}
              >
                {row.value ? (
                  row.value
                ) : (
                  <Box component="span" sx={{ color: 'text.disabled' }}>—</Box>
                )}
              </Typography>
              {row.value && (
                <CopyButton text={row.value} addressType={`${addressType}_${row.key}`} />
              )}
            </Box>
          ))}
        </Box>
      </Collapse>
    </Box>
  );
};

export default FormFieldsPane;
